<template>
  <router-view />
</template>

<script>
export default {
  name: "Penilaian",
};
</script>
